import { render } from "./InfoShipping.vue?vue&type=template&id=435b347f"
import script from "./InfoShipping.vue?vue&type=script&lang=js"
export * from "./InfoShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__